<template>
<!--     <div class="authentication">
      <v-content>
        <div v-if="user.uid" key="login" class="navbar-item">
          error
        </div>
        <div v-else key="logout">
          <button type="button" class="twitter-button" @click="doLogin">
            <span class="twitter-button__text">Sign in with Twitter</span>
          </button>
          <button type="button" class="" @click="doLoginAnonymouse">
            <span class="">匿名ログイン</span>
          </button>
        </div>
      </v-content>
    </div> -->
  <v-content class="mt-12">
    <v-card class="mx-auto" max-width="320" height="350" shaped>
      <v-card-title class="pl-9 py-2">Sign in</v-card-title>
      <div id="firebaseui-auth-container"></div>      
    </v-card>
  </v-content>
</template>
<script>
import Firebase from './../firebase'
import "firebaseui/dist/firebaseui.css"
import * as firebase from "firebase/app"
import "firebase/auth"
import * as firebaseui from 'firebaseui'

export default {
  created () {
  },
  mounted() {
    var uiConfig = {
      signInOptions: [
        firebase.auth.GoogleAuthProvider.PROVIDER_ID,
        firebase.auth.TwitterAuthProvider.PROVIDER_ID,
        firebase.auth.EmailAuthProvider.PROVIDER_ID,
        firebaseui.auth.AnonymousAuthProvider.PROVIDER_ID
      ],
    }
    const ui = firebaseui.auth.AuthUI.getInstance() || new firebaseui.auth.AuthUI(firebase.auth())
    ui.start('#firebaseui-auth-container', uiConfig)
  },
  computed: {
    user() {
      return this.$store.getters.user;
    },
  },
  methods: {
    // ログイン処理
    // doLogin() {
    //   Firebase.login()
    // },
    // doLoginAnonymouse() {
    //   Firebase.loginAnonymouse()
    // },
    // ログアウト処理
    doLogout() {
      Firebase.logout();
    }
  },
}
</script>

<style>
.firebaseui-idp-list{
  padding: 0 !important
}

</style>
